"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[25567],{

/***/ 66283:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45987);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86010);
/* harmony import */ var _Typography__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22318);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(40922);
/* harmony import */ var _FormControl_FormControlContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15736);








var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'flex',
    height: '0.01em',
    // Fix IE 11 flexbox alignment. To remove at some point.
    maxHeight: '2em',
    alignItems: 'center',
    whiteSpace: 'nowrap'
  },

  /* Styles applied to the root element if `variant="filled"`. */
  filled: {
    '&$positionStart:not($hiddenLabel)': {
      marginTop: 16
    }
  },

  /* Styles applied to the root element if `position="start"`. */
  positionStart: {
    marginRight: 8
  },

  /* Styles applied to the root element if `position="end"`. */
  positionEnd: {
    marginLeft: 8
  },

  /* Styles applied to the root element if `disablePointerEvents=true`. */
  disablePointerEvents: {
    pointerEvents: 'none'
  },

  /* Styles applied if the adornment is used inside <FormControl hiddenLabel />. */
  hiddenLabel: {},

  /* Styles applied if the adornment is used inside <FormControl margin="dense" />. */
  marginDense: {}
};
var InputAdornment = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function InputAdornment(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      _props$disablePointer = props.disablePointerEvents,
      disablePointerEvents = _props$disablePointer === void 0 ? false : _props$disablePointer,
      _props$disableTypogra = props.disableTypography,
      disableTypography = _props$disableTypogra === void 0 ? false : _props$disableTypogra,
      position = props.position,
      variantProp = props.variant,
      other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(props, ["children", "classes", "className", "component", "disablePointerEvents", "disableTypography", "position", "variant"]);

  var muiFormControl = (0,_FormControl_FormControlContext__WEBPACK_IMPORTED_MODULE_2__/* .useFormControl */ .Y)() || {};
  var variant = variantProp;

  if (variantProp && muiFormControl.variant) {
    if (false) {}
  }

  if (muiFormControl && !variant) {
    variant = muiFormControl.variant;
  }

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_FormControl_FormControlContext__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Provider */ .Z.Provider, {
    value: null
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(classes.root, className, position === 'end' ? classes.positionEnd : classes.positionStart, disablePointerEvents && classes.disablePointerEvents, muiFormControl.hiddenLabel && classes.hiddenLabel, variant === 'filled' && classes.filled, muiFormControl.margin === 'dense' && classes.marginDense),
    ref: ref
  }, other), typeof children === 'string' && !disableTypography ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Typography__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
    color: "textSecondary"
  }, children) : children));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(styles, {
  name: 'MuiInputAdornment'
})(InputAdornment));

/***/ }),

/***/ 28358:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45987);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4942);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86010);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(40922);







var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center'
    },

    /* Styles applied to the root element if `disableGutters={false}`. */
    gutters: (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    }, theme.breakpoints.up('sm'), {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3)
    }),

    /* Styles applied to the root element if `variant="regular"`. */
    regular: theme.mixins.toolbar,

    /* Styles applied to the root element if `variant="dense"`. */
    dense: {
      minHeight: 48
    }
  };
};
var Toolbar = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Toolbar(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      _props$disableGutters = props.disableGutters,
      disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'regular' : _props$variant,
      other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props, ["classes", "className", "component", "disableGutters", "variant"]);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(classes.root, classes[variant], className, !disableGutters && classes.gutters),
    ref: ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(styles, {
  name: 'MuiToolbar'
})(Toolbar));

/***/ }),

/***/ 8522:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* reexport safe */ firebaseConfig_config__WEBPACK_IMPORTED_MODULE_0__.vY; }
/* harmony export */ });
/* harmony import */ var firebaseConfig_config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36068);


(0,firebaseConfig_config__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)();



/***/ }),

/***/ 12766:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97582);
/* harmony import */ var components_FormatDate__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87936);
/* harmony import */ var components_Alert__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34950);
/* harmony import */ var components_ProjectFirestore__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79794);





var HistorySave = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(outputUrls, inputFile, appId, appName, appEmail, userName, inputType, outputType, price, email, category) {
        var createdAt, collectionRef, values, _tmp, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    createdAt = (0,components_FormatDate__WEBPACK_IMPORTED_MODULE_4__/* .FormatDate */ .r2)(new Date());
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        components_ProjectFirestore__WEBPACK_IMPORTED_MODULE_1__/* .projectFirestore.collection */ .H.collection("users").doc(email).collection("history")
                    ];
                case 2:
                    collectionRef = _state.sent();
                    _tmp = {};
                    values = (_tmp.createdAt = createdAt, _tmp.appId = appId, _tmp.appName = appName, _tmp.email = appEmail, _tmp.userName = userName, _tmp.inputType = inputType, _tmp.outputType = outputType, _tmp.inputFile = inputFile, _tmp.outputFile = outputUrls, _tmp.price = price, _tmp.review = "", _tmp.reviewedAt = "", _tmp.comment = "", _tmp.commentedAt = "", _tmp.visible = true, _tmp.category = category, _tmp);
                    return [
                        4,
                        collectionRef.add(values)
                    ];
                case 3:
                    _state.sent();
                    return [
                        3,
                        5
                    ];
                case 4:
                    error = _state.sent();
                    (0,components_Alert__WEBPACK_IMPORTED_MODULE_0__/* .BasicAlert */ .N)("히스토리 저장 실패");
                    return [
                        3,
                        5
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return function HistorySave(outputUrls, inputFile, appId, appName, appEmail, userName, inputType, outputType, price, email, category) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ __webpack_exports__["Z"] = (HistorySave);


/***/ }),

/***/ 14775:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97582);
/* harmony import */ var jsonwebtoken__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49704);
/* harmony import */ var jsonwebtoken__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jsonwebtoken__WEBPACK_IMPORTED_MODULE_0__);



var jwtToken = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        var tokenValue, tokenParseValue, email, sendToken, _tmp, _tmp1, guestTokenValue, tokenParseValue1, guestId, sendToken1, _tmp2, _tmp3;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            tokenValue = window.localStorage.getItem("aisoToken");
            _tmp = {};
            _tmp1 = {};
            if (tokenValue !== "" && tokenValue !== null) {
                tokenParseValue = jsonwebtoken__WEBPACK_IMPORTED_MODULE_0__.verify(tokenValue, "sdkjkdlsAESRcdslkch");
                email = tokenParseValue.email;
                sendToken = jsonwebtoken__WEBPACK_IMPORTED_MODULE_0__.sign((_tmp.email = email, _tmp), "sdkjkdlsAESRcdslkch", (_tmp1.expiresIn = "1d", _tmp1));
                return [
                    2,
                    sendToken
                ];
            }
            guestTokenValue = window.localStorage.getItem("guestToken");
            _tmp2 = {};
            _tmp3 = {};
            if (guestTokenValue !== "" && guestTokenValue !== null) {
                tokenParseValue1 = jsonwebtoken__WEBPACK_IMPORTED_MODULE_0__.verify(guestTokenValue, "sdkjkdlsAESRcdslkch");
                guestId = tokenParseValue1.guestId;
                sendToken1 = jsonwebtoken__WEBPACK_IMPORTED_MODULE_0__.sign((_tmp2.email = guestId, _tmp2), "sdkjkdlsAESRcdslkch", (_tmp3.expiresIn = "1d", _tmp3));
                return [
                    2,
                    sendToken1
                ];
            }
            return [
                2,
                ""
            ];
        });
    });
    return function jwtToken() {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ __webpack_exports__["Z"] = (jwtToken);


/***/ }),

/***/ 99762:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_dropzone__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32512);
/* harmony import */ var components_FormatDate__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(87936);
/* harmony import */ var components_Alert__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34950);
/* harmony import */ var stores_settings__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31806);
/* harmony import */ var function_HistorySave__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(12766);
/* harmony import */ var node_fetch__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(83300);
/* harmony import */ var node_fetch__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(node_fetch__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _material_ui_core_Paper__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(79895);
/* harmony import */ var _devexpress_dx_react_grid__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(48994);
/* harmony import */ var _devexpress_dx_react_grid_material_ui__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(13716);
/* harmony import */ var function_JwtToken__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(14775);
/* harmony import */ var components_ProjectStorage__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(8522);
/* harmony import */ var jsonwebtoken__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(49704);
/* harmony import */ var jsonwebtoken__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(jsonwebtoken__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var function_JsonWebTokenCheck__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(39304);
/* harmony import */ var components_dataAnalysisTabs_DataAnalysisDetailTab__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(82778);
/** @format */ 









// import LikeUpdate from "function/LikeUpdate";










var AppBody = function(param) {
    var email = param.email, appId = param.appId, inputType = param.inputType, outputType = param.outputType, appName = param.appName, price = param.price, userName = param.userName, inputFile = param.inputFile, target = param.target, csvInfo = param.csvInfo, outputJson = param.outputJson, outputHtml = param.outputHtml, category = param.category;
    var linkDownload = /** 파일 다운로드 */ function linkDownload(filename, content) {
        var link = document.createElement("a");
        var contentType = "data:application/csv;charset=utf-8,";
        var uriContent = contentType + encodeURIComponent(content);
        link.setAttribute("href", uriContent);
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    var settings = (0,stores_settings__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
    /** 업로드 파일 값 저장 */ var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("none"), uploadFileCheck = ref[0], setUploadFileCheck = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), file = ref1[0], setFile = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), testType = ref2[0], setTestType = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), outputFile = ref3[0], setOutputFile = ref3[1];
    /** csv 데이터 값 저장 */ var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), columns = ref4[0], setColumns = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), fields = ref5[0], setFields = ref5[1];
    // const [columnList, setColumnList] = useState([]);
    /** 테이블로 보여줄 결과 값 저장 */ var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), columnDefs = ref6[0], setColumnDefs = ref6[1];
    var ref7 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), rowData = ref7[0], setRowData = ref7[1];
    /** 샘플 파일 데이터 저장 */ var ref8 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), downloadFileData = ref8[0], setDownloadFileData = ref8[1];
    var ref9 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), getUrl = ref9[0], setGetUrl = ref9[1];
    /* 사용자 이메일 정보 저장 */ var ref10 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), userEmail = ref10[0], setUserEmail = ref10[1];
    /* tab */ var ref11 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("file"), tab = ref11[0], setTab = ref11[1];
    /* 입력 테이블 값 저장 및 수정 */ var ref12 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), defaultColumnWidths = ref12[0], setDefaultColumnWidths = ref12[1];
    var commitChanges = function(param) {
        var changed = param.changed;
        var changedRows;
        if (changed) {
            changedRows = fields.map(function(row) {
                return changed[0] ? (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, row, changed[0]) : row;
            });
        }
        setFields(changedRows);
    };
    /* 로그인 체크, 이메일 정보 저장 */ (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (settings.email) {
            setUserEmail(settings.email);
        } else {
            /* 비회원인 경우 */ var guestTokenValue = window.localStorage.getItem("guestToken");
            // const tokenParseValue = jwt.verify(guestTokenValue, process.env.SECRET_CODE);
            if (guestTokenValue === "" || guestTokenValue === null) {
                settings.login = false;
                settings.email = "";
                settings.name = "";
                settings.photo = "";
                settings.uid = "";
            // window.localStorage.removeItem("aisoToken");
            } else {
                jsonwebtoken__WEBPACK_IMPORTED_MODULE_11__.verify(guestTokenValue, "sdkjkdlsAESRcdslkch", function() {
                    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(function(error, decoded) {
                        var guestId;
                        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_16__.__generator)(this, function(_state) {
                            if (error) {
                                ;
                                (0,function_JsonWebTokenCheck__WEBPACK_IMPORTED_MODULE_12__/* .JsonWebTokenCheck */ .U)(settings);
                            } else {
                                guestId = decoded.guestId;
                                setUserEmail(guestId);
                            }
                            return [
                                2
                            ];
                        });
                    });
                    return function(error, decoded) {
                        return _ref.apply(this, arguments);
                    };
                }());
            }
        }
    }, [
        settings
    ]);
    /**
   * input File => csv 파일 읽어오기
   * 입력값 및 샘플 데이터 값을 저장하기 위함.
   * */ (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(function() {
        var storageFileRef;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_16__.__generator)(this, function(_state) {
            if (inputFile) {
                storageFileRef = components_ProjectStorage__WEBPACK_IMPORTED_MODULE_10__/* .projectStorage.ref */ .v.ref(inputFile);
                storageFileRef.getDownloadURL().then(function(url) {
                    setGetUrl(url);
                }).catch(function(error) {
                    ;
                });
            }
            return [
                2
            ];
        });
    }), []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(function() {
        var res, result, _loop, rows, columnString, fieldString, column, field, tempColumn, tempField, i, tempInputColumns, tempDefaultColumnWidths, i1, value, tempColumn2, _tmp, tempColumn3, _tmp1, tempInputFields, tempField2, i2, value1, tempDownloadFileData;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_16__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!getUrl) return [
                        3,
                        11
                    ];
                    return [
                        4,
                        node_fetch__WEBPACK_IMPORTED_MODULE_6___default()(getUrl)
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        4,
                        res.text()
                    ];
                case 2:
                    result = _state.sent();
                    if (!(result !== "" && result.indexOf("<!DOCTYPE html><html><head>") === -1)) return [
                        3,
                        11
                    ];
                    _loop = function(i) {
                        var findIndex = column.findIndex(function(f) {
                            return f == target[i];
                        });
                        tempColumn = tempColumn.filter(function(f) {
                            return f !== target[i];
                        });
                        tempField = tempField.filter(function(f, index) {
                            return index !== findIndex;
                        });
                    };
                    return [
                        4,
                        result.split("\n")
                    ];
                case 3:
                    rows = _state.sent();
                    return [
                        4,
                        rows[0]
                    ];
                case 4:
                    columnString = _state.sent();
                    return [
                        4,
                        rows[1]
                    ];
                case 5:
                    fieldString = _state.sent();
                    column = columnString.replace(/(\")/g, "").split(",");
                    field = fieldString.replace(/(\")/g, "").split(",");
                    tempColumn = column;
                    tempField = field;
                    for(var i in target)_loop(i);
                    tempInputColumns = [];
                    tempDefaultColumnWidths = [];
                    i1 = 0;
                    _state.label = 6;
                case 6:
                    if (!(i1 < tempColumn.length)) return [
                        3,
                        10
                    ];
                    if (!tempColumn[i1]) return [
                        3,
                        9
                    ];
                    value = tempColumn[i1].trim();
                    _tmp = {};
                    tempColumn2 = (_tmp.name = value, _tmp.title = value, _tmp);
                    _tmp1 = {};
                    tempColumn3 = (_tmp1.columnName = value, _tmp1.width = 180, _tmp1);
                    return [
                        4,
                        tempInputColumns.push(tempColumn2)
                    ];
                case 7:
                    _state.sent();
                    return [
                        4,
                        tempDefaultColumnWidths.push(tempColumn3)
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    i1++;
                    return [
                        3,
                        6
                    ];
                case 10:
                    tempInputFields = [];
                    tempField2 = new Object();
                    for(i2 = 0; i2 < tempField.length; i2++){
                        if (tempColumn[i2]) {
                            value1 = tempColumn[i2].trim();
                            tempField2[value1] = tempField[i2];
                        }
                    }
                    tempInputFields.push(tempField2);
                    setColumns(tempInputColumns);
                    setFields(tempInputFields);
                    setDefaultColumnWidths(tempDefaultColumnWidths);
                    tempDownloadFileData = "";
                    tempColumn.map(function(m) {
                        return tempDownloadFileData += m + ",";
                    });
                    tempDownloadFileData = tempDownloadFileData.substring(0, tempDownloadFileData.length - 1);
                    tempDownloadFileData += "\n";
                    tempField.map(function(m) {
                        return tempDownloadFileData += m + ",";
                    });
                    tempDownloadFileData = tempDownloadFileData.substring(0, tempDownloadFileData.length - 1);
                    setDownloadFileData(tempDownloadFileData);
                    _state.label = 11;
                case 11:
                    return [
                        2
                    ];
            }
        });
    }), [
        getUrl
    ]);
    /** 파일 업로드 */ var onDrop = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(function(acceptedFiles) {
            var fileName, createdAt, storageFilePath, storageFileRef;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_16__.__generator)(this, function(_state) {
                if (!acceptedFiles[0]) return [
                    2,
                    ""
                ];
                setOutputFile();
                setUploadFileCheck("uploading");
                setFile(acceptedFiles[0]);
                setTestType(true);
                fileName = acceptedFiles[0].name;
                createdAt = (0,components_FormatDate__WEBPACK_IMPORTED_MODULE_17__/* .FormatOnlyDate */ .ll)(new Date());
                storageFilePath = "users/".concat(userEmail, "/dataAnalysis/inputFile/file_").concat(createdAt, "_").concat(fileName);
                storageFileRef = components_ProjectStorage__WEBPACK_IMPORTED_MODULE_10__/* .projectStorage.ref */ .v.ref(storageFilePath);
                /** 파일 업로드 */ if (acceptedFiles[0]) {
                    storageFileRef.put(acceptedFiles[0]).on("state_changed", function(snap) {
                        var percentage = snap.bytesTransferred / snap.totalBytes * 100;
                        ;
                    // setProgress(percentage);
                    }, function(err) {
                        ;
                    }, /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(function() {
                        var inputUrl;
                        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_16__.__generator)(this, function(_state) {
                            inputUrl = "https://storage.cloud.google.com/aiso-api.appspot.com/".concat(storageFilePath);
                            dataAnalysisTestSend(inputUrl, fileName, storageFilePath);
                            return [
                                2
                            ];
                        });
                    }));
                }
                return [
                    2
                ];
            });
        });
        return function onDrop(acceptedFiles) {
            return _ref.apply(this, arguments);
        };
    }();
    /** 파일 업로드 이후 데이터 분석 실행 */ var dataAnalysisTestSend = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(function(inputUrl, fileName, storageFilePath) {
            var sendData, _tmp, idToken, requestOptions, _tmp1, jsonData, result, outputUrl, text;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_16__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        sendData = (_tmp.input_url = inputUrl, _tmp.appId = appId, _tmp.email = userEmail, _tmp.appEmail = email, _tmp.method = "file", _tmp.runType = "dataAnalysis_app", _tmp);
                        return [
                            4,
                            (0,function_JwtToken__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)()
                        ];
                    case 1:
                        idToken = _state.sent();
                        _tmp1 = {};
                        requestOptions = (_tmp1.headers = {
                            "Content-Type": "application/json",
                            Authorization: "Bearer ".concat(idToken)
                        }, _tmp1.method = "POST", _tmp1.body = JSON.stringify(sendData), _tmp1);
                        return [
                            4,
                            node_fetch__WEBPACK_IMPORTED_MODULE_6___default()("".concat("https://aiso-analysis-run-app-7sb7m2frsq-du.a.run.app"), requestOptions)
                        ];
                    case 2:
                        jsonData = _state.sent();
                        return [
                            4,
                            jsonData.json()
                        ];
                    case 3:
                        result = _state.sent();
                        if (!(result.msg === "ok")) return [
                            3,
                            6
                        ];
                        outputUrl = result["output_url"].replace("https://storage.cloud.google.com/aiso-api.appspot.com/", "");
                        /* output 파일 다운받기 */ // await downloadUrlSave(outputUrl);
                        setOutputFile(outputUrl);
                        setUploadFileCheck("uploaded");
                        if (!settings.email) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            (0,function_HistorySave__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(outputUrl, storageFilePath, appId, appName, email, userName, inputType, outputType, price, userEmail, category)
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        return [
                            3,
                            7
                        ];
                    case 6:
                        text = result.msg;
                        (0,components_Alert__WEBPACK_IMPORTED_MODULE_3__/* .BasicAlert */ .N)(text);
                        setOutputFile();
                        setUploadFileCheck("none");
                        setTestType(false);
                        _state.label = 7;
                    case 7:
                        return [
                            2
                        ];
                }
            });
        });
        return function dataAnalysisTestSend(inputUrl, fileName, storageFilePath) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleFileDownload = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(function() {
            var storageFileRef;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_16__.__generator)(this, function(_state) {
                storageFileRef = components_ProjectStorage__WEBPACK_IMPORTED_MODULE_10__/* .projectStorage.ref */ .v.ref(outputFile);
                storageFileRef.getDownloadURL().then(function() {
                    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(function(url) {
                        var res, result;
                        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_16__.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        node_fetch__WEBPACK_IMPORTED_MODULE_6___default()(url)
                                    ];
                                case 1:
                                    res = _state.sent();
                                    return [
                                        4,
                                        res.text()
                                    ];
                                case 2:
                                    result = _state.sent();
                                    if (result !== "" && result.indexOf("<!DOCTYPE html><html><head>") === -1) {
                                        linkDownload(file.name, result);
                                    }
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(url) {
                        return _ref.apply(this, arguments);
                    };
                }()).catch(function(error) {
                    ;
                });
                return [
                    2
                ];
            });
        });
        return function handleFileDownload() {
            return _ref.apply(this, arguments);
        };
    }();
    /** 데이터 분석 샘플 데이터 다운로드 */ var handleSampleFileDownload = function() {
        linkDownload("analysis_sample_data.csv", downloadFileData);
    };
    /** 테스트 데이터 값 직접 입력 이후 데이터 분석 실행 */ var handleTestAnalysis = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(function() {
            var tempFile, userInput, i, tempFields, tempColumn, tempValue, method, sendData, _tmp, idToken, requestOptions, _tmp1, jsonData, result, outputUrl, storageFileRef, text;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_16__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        tempFile = new Object();
                        tempFile.name = "".concat(appName, "_inputData.csv");
                        setFile(tempFile);
                        setColumnDefs([]);
                        setRowData([]);
                        setUploadFileCheck("uploading");
                        setTestType(false);
                        userInput = new Object();
                        for(var i in Object.keys(fields[0])){
                            tempFields = Object.keys(fields[0]);
                            tempColumn = tempFields[i];
                            tempValue = Object.values(fields[0])[i];
                            userInput["".concat(tempColumn)] = [
                                "".concat(tempValue)
                            ];
                        }
                        method = "userInput"; // file or userInput;
                        _tmp = {};
                        sendData = (_tmp.email = userEmail, _tmp.appId = appId, _tmp.appEmail = email, _tmp.method = method, _tmp.userInput = userInput, _tmp.runType = "dataAnalysis_app", _tmp);
                        return [
                            4,
                            (0,function_JwtToken__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)()
                        ];
                    case 1:
                        idToken = _state.sent();
                        _tmp1 = {};
                        requestOptions = (_tmp1.headers = {
                            "Content-Type": "application/json",
                            Authorization: "Bearer ".concat(idToken)
                        }, _tmp1.method = "POST", _tmp1.body = JSON.stringify(sendData), _tmp1);
                        return [
                            4,
                            node_fetch__WEBPACK_IMPORTED_MODULE_6___default()("".concat("https://aiso-analysis-run-app-7sb7m2frsq-du.a.run.app"), requestOptions)
                        ];
                    case 2:
                        jsonData = _state.sent();
                        return [
                            4,
                            jsonData.json()
                        ];
                    case 3:
                        result = _state.sent();
                        if (!(result.msg === "ok")) return [
                            3,
                            6
                        ];
                        outputUrl = result["output_url"].replace("https://storage.cloud.google.com/aiso-api.appspot.com/", "");
                        if (!settings.email) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            (0,function_HistorySave__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(outputUrl, "", appId, appName, email, userName, inputType, outputType, price, userEmail, category)
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        // 결과 값 보여주기....
                        if (outputUrl) {
                            storageFileRef = components_ProjectStorage__WEBPACK_IMPORTED_MODULE_10__/* .projectStorage.ref */ .v.ref(outputUrl);
                            storageFileRef.getDownloadURL().then(function() {
                                var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(function(url) {
                                    var res, result, rows, column, tempColumnDefs, i, tempColumn, _tmp, tempRowData, i1, row, tempField, j, text, _tmp1;
                                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_16__.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                return [
                                                    4,
                                                    node_fetch__WEBPACK_IMPORTED_MODULE_6___default()(url)
                                                ];
                                            case 1:
                                                res = _state.sent();
                                                return [
                                                    4,
                                                    res.text()
                                                ];
                                            case 2:
                                                result = _state.sent();
                                                _tmp = {};
                                                _tmp1 = {};
                                                if (result !== "" && result.indexOf("<!DOCTYPE html><html><head>") === -1) {
                                                    rows = result.split("\n");
                                                    column = rows[0].split(",");
                                                    tempColumnDefs = [];
                                                    for(i = 0; i < column.length; i++){
                                                        tempColumn = (_tmp.headerName = column[i], _tmp.cellStyle = {
                                                            "border-right-color": "#e2e2e2"
                                                        }, _tmp.field = column[i], _tmp);
                                                        tempColumnDefs.push(tempColumn);
                                                    }
                                                    tempRowData = [];
                                                    for(i1 = 1; i1 < rows.length - 1; i1++){
                                                        row = rows[i1].split(",");
                                                        tempField = new Object();
                                                        for(j = 0; j < row.length; j++){
                                                            tempField[column[j]] = row[j].toString();
                                                        }
                                                        tempRowData.push(tempField);
                                                    }
                                                    /* output 파일 다운받기 */ setOutputFile(outputUrl);
                                                    /* 결과 값 저장 */ setColumnDefs(tempColumnDefs);
                                                    setRowData(tempRowData);
                                                    setUploadFileCheck("uploaded");
                                                    setTestType(false);
                                                } else {
                                                    text = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", (_tmp1.children = [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            children: "분석에 실패하였습니다."
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "mt-1",
                                                            children: "데이터를 확인 해주세요."
                                                        })
                                                    ], _tmp1));
                                                    (0,components_Alert__WEBPACK_IMPORTED_MODULE_3__/* .BasicAlert */ .N)(text);
                                                    setUploadFileCheck("none");
                                                    setFile();
                                                    setTestType(false);
                                                }
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                                return function(url) {
                                    return _ref.apply(this, arguments);
                                };
                            }()).catch(function(error) {
                                ;
                            });
                        }
                        return [
                            3,
                            7
                        ];
                    case 6:
                        text = result.msg;
                        (0,components_Alert__WEBPACK_IMPORTED_MODULE_3__/* .BasicAlert */ .N)(text);
                        setUploadFileCheck("none");
                        setTestType(false);
                        _state.label = 7;
                    case 7:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleTestAnalysis() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "w-full px-6 md:px-32",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "pt-10 pb-4 sm:flex justify-between items-start",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "text-xl font-bold text-black break-all sm:pr-5",
                        children: appName
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                        className: "text-base text-black font-gmarket-medium font-bold min-w-max flex justify-end items-center",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "font-bold text-lg text-black mr-1",
                                children: price
                            }),
                            " Credit"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "overflow-x-auto",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                    className: "flex w-full",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                type: "",
                                className: "btn glass_in_outline_btn font-bold min-w-max mr-3 ".concat(tab === "file" ? "active" : ""),
                                onClick: function() {
                                    return setTab("file");
                                },
                                children: "파일 업로드"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                type: "",
                                className: "btn glass_in_outline_btn font-bold min-w-max ".concat(tab === "input" ? "active" : ""),
                                onClick: function() {
                                    return setTab("input");
                                },
                                children: "데이터 입력"
                            })
                        })
                    ]
                })
            }),
            tab === "file" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FileTable, {
                uploadFileCheck: uploadFileCheck,
                file: file,
                handleFileDownload: handleFileDownload,
                handleSampleFileDownload: handleSampleFileDownload,
                onDrop: onDrop
            }) : "",
            tab === "input" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "h-full flex flex-col sm:flex-row items-center aiso-data-card shadow-md mb-3",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "w-full px-3 py-4",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                            className: "mb-4 font-bold center",
                            children: "데이터를 입력하여 테스트해 보세요"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "w-full",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(InputTable, {
                                columns: columns,
                                fields: fields,
                                commitChanges: commitChanges,
                                defaultColumnWidths: defaultColumnWidths,
                                handleTestAnalysis: handleTestAnalysis,
                                uploadFileCheck: uploadFileCheck,
                                testType: testType,
                                columnDefs: columnDefs,
                                rowData: rowData
                            })
                        })
                    ]
                })
            }) : "",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dataAnalysisTabs_DataAnalysisDetailTab__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                csvInfo: csvInfo,
                target: target,
                outputJson: outputJson,
                outputHtml: outputHtml
            })
        ]
    });
};
/* 파일 업로드 테이블 */ var FileTable = function(param) {
    var uploadFileCheck = param.uploadFileCheck, file = param.file, handleFileDownload = param.handleFileDownload, onDrop = param.onDrop, handleSampleFileDownload = param.handleSampleFileDownload;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "h-full flex flex-col sm:flex-row items-center aiso-data-card shadow-md mb-3",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "w-full px-3 py-4",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "row center",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "col-12 col-md-7",
                        children: uploadFileCheck === "uploaded" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                            className: "center bg-gray-input h-44 rounded-2xl",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "w-full flex items-center justify-center mt-4",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "text-999",
                                        children: file.name
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "w-full text-center m-2",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                        type: "button",
                                        className: "btn btn-primary btn-icon-text",
                                        onClick: handleFileDownload,
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                className: "ti-download btn-icon-prepend"
                                            }),
                                            "결과 다운로드"
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_dropzone__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    accept: ".csv",
                                    onDrop: onDrop,
                                    multiple: false,
                                    children: function(param) {
                                        var getRootProps = param.getRootProps, getInputProps = param.getInputProps;
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, getRootProps()), {
                                            className: "w-full flex flex-col items-center justify-center mt-3",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "w-full flex items-center justify-center",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, getInputProps())),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                        className: "mdi mdi-refresh"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        className: "btn text-xs btn-whitePrimary py-2 px-3",
                                                        children: "앱 재실행은 여기를 눌러주세요."
                                                    })
                                                ]
                                            })
                                        }));
                                    }
                                })
                            ]
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_dropzone__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            accept: ".csv",
                            onDrop: onDrop,
                            multiple: false,
                            children: function(param) {
                                var getRootProps = param.getRootProps, getInputProps = param.getInputProps;
                                return file ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                                    className: "center bg-gray-input h-52 rounded-2xl",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, getRootProps()), {
                                        className: "w-full flex flex-col items-center justify-center mt-4",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "z-50 loader-demo-box2 mt-2",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "dot-opacity-loader",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {}),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {}),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {})
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "w-full text-center -mt-6",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        className: "text-888 mt-2 font-bold",
                                                        children: "데이터 분석중 입니다."
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        className: "text-888 font-bold",
                                                        children: "잠시만 기다려주세요."
                                                    })
                                                ]
                                            })
                                        ]
                                    }))
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                                    className: "w-full h-52 rounded-2xl bg-gray-input flex items-center",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, getRootProps()), {
                                        className: "w-full flex flex-col items-center justify-center mt-4",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                className: "mb-4 font-bold text-aaa",
                                                children: "파일을 업로드하여 테스트해 보세요"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "upload-circle-wrap",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "upload-circle"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                        className: "ti-upload text-primary font-bold absolute"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "text-primary font-bold mt-2",
                                                children: "Choose File"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "w-full flex items-center justify-center",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, getInputProps())),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        className: "text-aaa",
                                                        children: "Drag and drop your files here"
                                                    })
                                                ]
                                            })
                                        ]
                                    }))
                                });
                            }
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "row center mt-2",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "col-12 col-md-7",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "p-3 bg-gray-input rounded-xl",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "md:flex justify-between items-center",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "flex flex-col items-start lg:mb-0 mb-2",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                className: "mb-0",
                                                children: "테스트할 파일이 없으신가요?"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "text-888 mb-0 text-xs",
                                                children: "아이소에서 제공하는 csv테스트 파일을 사용하여 테스트해 보세요"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                        type: "text",
                                        className: "btn btn-whitePrimary font-bold",
                                        onClick: handleSampleFileDownload,
                                        children: "파일 다운로드"
                                    })
                                ]
                            })
                        })
                    })
                })
            ]
        })
    });
};
/* 데이터 입력 테이블 */ var InputTable = function(param) {
    var columns = param.columns, fields = param.fields, commitChanges = param.commitChanges, defaultColumnWidths = param.defaultColumnWidths, handleTestAnalysis = param.handleTestAnalysis, uploadFileCheck = param.uploadFileCheck, testType = param.testType, rowData = param.rowData, columnDefs = param.columnDefs;
    if (!defaultColumnWidths) return "";
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(defaultColumnWidths), columnWidths = ref[0], setColumnWidths = ref[1];
    var handleAnalysisButton = function() {
        handleTestAnalysis();
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setColumnWidths(defaultColumnWidths);
    }, [
        defaultColumnWidths
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "w-full border-t mt-4 pt-3",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "overflow-x-auto",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex flex-col w-full",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "border-t",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Paper__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_devexpress_dx_react_grid_material_ui__WEBPACK_IMPORTED_MODULE_8__/* .Grid */ .rj, {
                                    rows: fields,
                                    columns: columns,
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_devexpress_dx_react_grid__WEBPACK_IMPORTED_MODULE_7__/* .EditingState */ .C7, {
                                            onCommitChanges: commitChanges
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_devexpress_dx_react_grid_material_ui__WEBPACK_IMPORTED_MODULE_8__/* .Table */ .cO, {}),
                                        columnWidths ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_devexpress_dx_react_grid_material_ui__WEBPACK_IMPORTED_MODULE_8__/* .TableColumnResizing */ .ad, {
                                            defaultColumnWidths: columnWidths
                                        }) : "",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_devexpress_dx_react_grid_material_ui__WEBPACK_IMPORTED_MODULE_8__/* .TableHeaderRow */ .KA, {}),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_devexpress_dx_react_grid_material_ui__WEBPACK_IMPORTED_MODULE_8__/* .TableInlineCellEditing */ .WI, {})
                                    ]
                                })
                            })
                        }),
                        testType ? "" : uploadFileCheck === "uploading" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                            className: "mt-16 center bg-gray-input h-44 rounded-2xl",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "w-full flex flex-col items-center justify-center mt-4",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "z-50 loader-demo-box2 mt-2",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "dot-opacity-loader",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {}),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {}),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {})
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "w-full text-center -mt-6",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "text-888 mt-2 font-bold",
                                                children: "분석결과 입력중 입니다."
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "text-888 font-bold",
                                                children: "잠시만 기다려주세요."
                                            })
                                        ]
                                    })
                                ]
                            })
                        }) : rowData && rowData.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "row flex items-center justify-center mt-16",
                            children: columnDefs.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex font-bold text-333 py-2 px-3 bg-gray-input rounded-md mr-3 mb-2.5",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "mb-0 text-aaa font-bold mr-3 text-lg",
                                        children: columnDefs[columnDefs.length - 1].field
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "mt-1 font-bold text-333 bg-gray-input rounded-md",
                                        children: rowData[0][columnDefs[columnDefs.length - 1].field]
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex justify-end mt-2",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    className: "btn btn-primary text-xs px-2.5 py-1.5",
                    onClick: handleAnalysisButton,
                    children: "분석하기"
                })
            })
        ]
    });
};
/* 파일 설명 */ /* 데이터 분석 */ /* 알고리즘 */ /* harmony default export */ __webpack_exports__["default"] = (AppBody);


/***/ }),

/***/ 83300:
/***/ (function(module, exports) {



// ref: https://github.com/tc39/proposal-global
var getGlobal = function () {
	// the only reliable means to get the global object is
	// `Function('return this')()`
	// However, this causes CSP violations in Chrome apps.
	if (typeof self !== 'undefined') { return self; }
	if (typeof window !== 'undefined') { return window; }
	if (typeof global !== 'undefined') { return global; }
	throw new Error('unable to locate global object');
}

var global = getGlobal();

module.exports = exports = global.fetch;

// Needed for TypeScript and Webpack.
if (global.fetch) {
	exports["default"] = global.fetch.bind(global);
}

exports.Headers = global.Headers;
exports.Request = global.Request;
exports.Response = global.Response;

/***/ }),

/***/ 53439:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ forEach; },
/* harmony export */   "U": function() { return /* binding */ map; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/**
 * Iterates through children that are typically specified as `props.children`,
 * but only maps over children that are "valid elements".
 *
 * The mapFunction provided index will be normalised to the components mapped,
 * so an invalid component would not increase the index.
 *
 */

function map(children, func) {
  var index = 0;
  return react__WEBPACK_IMPORTED_MODULE_0__.Children.map(children, function (child) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(child) ? func(child, index++) : child;
  });
}
/**
 * Iterates through children that are "valid elements".
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child with the index reflecting the position relative to "valid components".
 */


function forEach(children, func) {
  var index = 0;
  react__WEBPACK_IMPORTED_MODULE_0__.Children.forEach(children, function (child) {
    if ( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(child)) func(child, index++);
  });
}



/***/ }),

/***/ 85509:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(63366);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var prop_types_extra_lib_isRequiredForA11y__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55638);
/* harmony import */ var prop_types_extra_lib_isRequiredForA11y__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types_extra_lib_isRequiredForA11y__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var uncontrollable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80789);
/* harmony import */ var _Nav__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8918);
/* harmony import */ var _NavLink__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36358);
/* harmony import */ var _NavItem__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41244);
/* harmony import */ var _TabContainer__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(97184);
/* harmony import */ var _TabContent__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(28752);
/* harmony import */ var _TabPane__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(67849);
/* harmony import */ var _ElementChildren__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53439);












var defaultProps = {
  variant: 'tabs',
  mountOnEnter: false,
  unmountOnExit: false
};

function getDefaultActiveKey(children) {
  var defaultActiveKey;
  (0,_ElementChildren__WEBPACK_IMPORTED_MODULE_3__/* .forEach */ .E)(children, function (child) {
    if (defaultActiveKey == null) {
      defaultActiveKey = child.props.eventKey;
    }
  });
  return defaultActiveKey;
}

function renderTab(child) {
  var _child$props = child.props,
      title = _child$props.title,
      eventKey = _child$props.eventKey,
      disabled = _child$props.disabled,
      tabClassName = _child$props.tabClassName,
      id = _child$props.id;

  if (title == null) {
    return null;
  }

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_NavItem__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
    as: _NavLink__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z,
    eventKey: eventKey,
    disabled: disabled,
    id: id,
    className: tabClassName
  }, title);
}

var Tabs = function Tabs(props) {
  var _useUncontrolled = (0,uncontrollable__WEBPACK_IMPORTED_MODULE_2__/* .useUncontrolled */ .Ch)(props, {
    activeKey: 'onSelect'
  }),
      id = _useUncontrolled.id,
      onSelect = _useUncontrolled.onSelect,
      transition = _useUncontrolled.transition,
      mountOnEnter = _useUncontrolled.mountOnEnter,
      unmountOnExit = _useUncontrolled.unmountOnExit,
      children = _useUncontrolled.children,
      _useUncontrolled$acti = _useUncontrolled.activeKey,
      activeKey = _useUncontrolled$acti === void 0 ? getDefaultActiveKey(children) : _useUncontrolled$acti,
      controlledProps = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_useUncontrolled, ["id", "onSelect", "transition", "mountOnEnter", "unmountOnExit", "children", "activeKey"]);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_TabContainer__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
    id: id,
    activeKey: activeKey,
    onSelect: onSelect,
    transition: transition,
    mountOnEnter: mountOnEnter,
    unmountOnExit: unmountOnExit
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Nav__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, controlledProps, {
    role: "tablist",
    as: "nav"
  }), (0,_ElementChildren__WEBPACK_IMPORTED_MODULE_3__/* .map */ .U)(children, renderTab)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_TabContent__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, null, (0,_ElementChildren__WEBPACK_IMPORTED_MODULE_3__/* .map */ .U)(children, function (child) {
    var childProps = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, child.props);

    delete childProps.title;
    delete childProps.disabled;
    delete childProps.tabClassName;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_TabPane__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, childProps);
  })));
};

Tabs.defaultProps = defaultProps;
Tabs.displayName = 'Tabs';
/* harmony default export */ __webpack_exports__["Z"] = (Tabs);

/***/ })

}]);